import React, { useCallback, useEffect, useState } from 'react'
import { Template } from '../../Components/Template/template'
import {
    AlertType, DadosRelDiaCtaPagar, Fornecedor, FornecedorSearchBox, RetAPI, classBorderLabelDark, classBt, classBtSemDuration, classDivBackground,
    classDivBody, classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, classbtCeuAzul, classbtCinzaClaro, classbtColunasAzul
} from '../../Utils/Types'
import { IoPrint, IoSearch } from 'react-icons/io5'
import moment from 'moment'
import { TbReport } from 'react-icons/tb'
import { Funcoes } from '../../Utils/Funcoes'
import { ContaAPagarService } from './ContaAPagarService'
import { GridRelDiaContaPagar } from '../../Components/GridProducts/GridRelDiaContaAPagar'
import { ReportContaPagarPDF } from './pdf/report-contaPagar'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { DadosRelCtaPagarDetalhado, GridCtaPagarDetalhado } from '../../Components/GridProducts/GridRelCtaPagarDetalhado'
import { DataSearch, SearchBox } from '../../Components/SearchBox/SearchBox'
import { FornecedorService } from '../Fornecedor/FornecedorService'
import { AiOutlineClear } from 'react-icons/ai'

export const ContaAPagarRelatorios = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD');

    let dateF = moment()
        .utcOffset('-03:00')
        .add(30, 'days')
        .format('YYYY-MM-DD');

    // ---------- ATRIBUTOS FEEDBACK -----------------
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ------------- ATRIBUTOS FILTRO ----------------
    const [datai, setDatai] = useState(dateI)
    const [dataf, setDataf] = useState(dateF)
    const [tipoFiltro, setTipoFiltro] = useState("A")
    const [tipoRelatorio, setTipoRelatorio] = useState("Res")

    const [fornecedor, setFornecedor] = useState<FornecedorSearchBox[]>([])
    const [fornecedorList, setFornecedorList] = useState<FornecedorSearchBox[]>([])
    const [idFornecedor, setIdFornecedor] = useState(0)
    const [nomeFornecedor, setNomeFornecedor] = useState("")

    // ------------- DADOS DUPLICATA -----------------
    const [qtdDup, setQtdDup] = useState(0)
    const [totDup, setTotDup] = useState(0)

    // ---------- ATRIBUTOS GRID ---------------------
    const [dadosRelCtaPagarDet, setDadosRelCtaPagarDet] = useState<DadosRelCtaPagarDetalhado[]>([])
    const [dadosRelCtaPagar, setDadosRelCtaPagar] = useState<DadosRelDiaCtaPagar[]>([])

    // ------------- SEARCH BOX ----------------------
    const [visibleSearchBoxFornecedor, setVisibleSearchBoxFornecedor] = useState<boolean>(false)

    //------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ----------------------------------------------------------------//
    const getAttributes = async () => {
        setLoading(true)

        try {

            const resp = await FornecedorService.GetListFornecedor()
            setFornecedor(resp.data)
            setFornecedorList(resp.data)

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar os fornecedores`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroDupRel") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !visibleSearchBoxFornecedor && menuFiltro.classList.contains("max-h-[1000px]") && !loading) {
            await handleFilterClick();
        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter)
        document.addEventListener('keydown', handleTabPress)

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter)
            document.removeEventListener('keydown', handleTabPress)
        }

    }, [datai, dataf, idFornecedor, tipoFiltro, tipoRelatorio, visibleSearchBoxFornecedor, loading])

    useEffect(() => {
        getAttributes()
    }, [])

    useEffect(() => {
        //filterData()
        setDadosRelCtaPagar([])
        setDadosRelCtaPagarDet([])
        setQtdDup(0)
        setTotDup(0)
    }, [tipoFiltro, tipoRelatorio])

    const handleCloseMessage = () => {
        setVisible(false)
    }

    const inputFocus = () => {
        const inputElement = document.getElementById("data_inicial_report_dupPagar")
        inputElement?.focus()
    }

    const inputDesfocus = () => {
        const inputElement = document.getElementById("data_inicial_report_dupPagar")
        inputElement?.blur()
    }

    const searchBoxFocus = () => {
        setVisibleSearchBoxFornecedor(false)
    }

    //------------------------------------------------------------- FILTROS -----------------------------------------------------------------------------//
    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const tipoFiltroChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipoFiltro(e.target.value)
    }

    const tipoRelatorioChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipoRelatorio(e.target.value)
    }

    const handleFilterClick = async () => {
        setVisible(false)
        setLoading(true)

        try {

            inputDesfocus()
            setDadosRelCtaPagar([])
            setQtdDup(0)
            setTotDup(0)

            if (tipoRelatorio === "Res") {

                const dados = await ContaAPagarService.Resumo(datai, dataf, tipoFiltro, idFornecedor)

                if (dados.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(dados.msg || '')

                } else {

                    setDadosRelCtaPagar(dados.data)

                    if (dados.data.length > 0) {
                        setQtdDup(dados.data[dados.data.length - 1].somaDup)
                        setTotDup(dados.data[dados.data.length - 1].somaTotal)
                    }

                }

            } else if (tipoRelatorio === "Det") {

                const dados = await ContaAPagarService.ResumoDetalhado(datai, dataf, tipoFiltro, idFornecedor)

                if (dados.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(dados.msg || '')

                } else {

                    setDadosRelCtaPagarDet(dados.data || [])
                }

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possivel buscar os dados")

        } finally {

            const timer = setTimeout(() => {
                inputFocus()
                setLoading(false)
                clearTimeout(timer)
            }, 500)

        }
    }

    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroDupRel") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsDupRel") as HTMLDivElement

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[1000px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[1000px]")) {

                menuInputs.classList.remove("invisible")

                const timer = setTimeout(() => {
                    inputFocus()
                    clearTimeout(timer)
                }, 100)

            } else {

                menuInputs.classList.add("invisible")

            }

            event.currentTarget.blur();
        }
    }

    const handleLimparFiltros = () => {

        setDatai(dateI)
        setDataf(dateF)
        setTipoFiltro("A")
        setTipoRelatorio("Res")
        setIdFornecedor(0)
        setVisible(false)
        searchBoxFocus()
        inputFocus()
    }

    //------------------------------------------------------------------- FORNECEDOR -------------------------------------------------------------------------//
    const handleClearFornecedorSelecionada = useCallback(() => {
        const newFornList = [...fornecedor || []]
        setFornecedorList(newFornList)
        setIdFornecedor(0)
        setNomeFornecedor('')

        setVisibleSearchBoxFornecedor(false)
    }, [fornecedor])

    const handleFilterFornecedorClick = useCallback(async (description: string) => {

        if (description === "") {
            const newFornList = [...fornecedor || []]
            setFornecedorList(newFornList || [])

        } else {
            const newFornList = [...fornecedor || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setFornecedorList(newFornList || [])
        }

    }, [fornecedor])

    const handleFornecedorSelectClick = useCallback((v: FornecedorSearchBox) => {

        if (v) {
            const newFornList = [...fornecedor || []]
            setFornecedorList(newFornList)
            setIdFornecedor(v.id)
            setNomeFornecedor(v.description)
        }

        setVisibleSearchBoxFornecedor(false)

        //filterData()
    }, [fornecedor])

    const clickSearchBoxFornecedor = useCallback(() => {
        setVisibleSearchBoxFornecedor((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                inputFocusFornecedor()
            }
            return newState
        })
    }, [])

    const inputFocusFornecedor = () => {
        let inputSearch = document.getElementById(`inputSearchBox-fornecedor`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------- PDF ------------------------------------------------------------------------------------//
    const handleGerarPDFClick = async () => {

        setVisible(false)

        try {
            const header = [
                { text: 'Data Vencimento', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Qtd - Duplicatas', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Total(R$)', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
                { text: 'Acumulado(R$)', bold: true, fontSize: 9, margin: [0, 4, 0, 0] },
            ]

            const pdf = new ReportContaPagarPDF(dadosRelCtaPagar, dadosRelCtaPagarDet, header, datai, dataf, tipoFiltro, nomeFornecedor)

            if (dadosRelCtaPagar.length > 0) {

                pdf.GerarPDF(dadosRelCtaPagar)

            } else if (dadosRelCtaPagarDet.length > 0) {

                pdf.GerarPDFDetalhado(dadosRelCtaPagarDet)

            } else {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage("Sem registro para a impressão")
                    clearTimeout(timer)
                }, 250)

            }

        } catch (error) {
            const timer = setTimeout(() => {
                setVisible(true)
                setMessageType("DANGER")
                setMessage("Não foi possivel fazer a impressão. Por favor, tente novamente")
                clearTimeout(timer)
            }, 250)

        } finally {
            inputFocus()
        }
    }

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-12 md:col-span-8 flex flex-row items-center`}>
                            <TbReport className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Duplicatas a pagar - relatórios</span>
                        </div>

                        <div className={`relative col-span-6 md:col-span-2`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                        <div className={`relative col-span-6 md:col-span-2`}>
                            <button tabIndex={-1} className={`${classBt} ${classbtCeuAzul} h-9 disabled:bg-opacity-50 disabled:cursor-not-allowed`}
                                disabled={!(dadosRelCtaPagar.length > 0 || dadosRelCtaPagarDet.length > 0)} onClick={handleGerarPDFClick}>
                                <span className={`w-full h-full flex justify-center items-center`}> <IoPrint size="20px" className={`mr-2`} />Imprimir</span>
                            </button>
                        </div>

                    </div>

                    <div id='divInputsDupRel' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroDupRel' className={`relative max-h-[0px] h-[600px] sm:h-[530px] md:h-[300px] 2xl:h-[230px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-4 py-7 px-3`}>

                            <div className={`relative col-span-12 md:col-span-6 2xl:col-span-2 mt-1`}>
                                <input id='data_inicial_report_dupPagar' className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} onFocus={searchBoxFocus} onChange={handleChangeDtInicio} />
                                <label htmlFor="data_inicial_report_dupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{tipoFiltro === 'A' ? 'Data de Vencimento Inicial' : 'Data da Baixa Inicial'}</label>
                            </div>

                            <div className={`relative col-span-12 md:col-span-6 2xl:col-span-2 mt-1`}>
                                <input id='data_final_report_dupPagar' className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} onFocus={searchBoxFocus} onChange={handleChangeDtFim} />
                                <label htmlFor="data_final_report_dupPagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>{tipoFiltro === 'A' ? 'Data de Vencimento Final' : 'Data da Baixa Final'}</label>
                            </div>

                            <div className={`relative col-span-12 md:col-span-3 2xl:col-span-2 mt-1`}>
                                <select id='tipo_duplicatas' className={`${classInput} ${classInputDark} ${tipoFiltro === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} value={tipoFiltro} onFocus={searchBoxFocus} onChange={tipoFiltroChange}>
                                    <option value="A">Abertas</option>
                                    <option value="L">Liquidadas</option>
                                </select>
                                <label htmlFor="tipo_duplicatas" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Tipo de duplicata</label>
                            </div>

                            <div className={`relative col-span-12 md:col-span-3 2xl:col-span-2 mt-1`}>
                                <select id='tipo_relatorio' className={`${classInput} ${classInputDark} ${tipoRelatorio === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} value={tipoRelatorio} onFocus={searchBoxFocus} onChange={tipoRelatorioChange}>
                                    <option value="Det">Detalhado</option>
                                    <option value="Res">Resumido</option>
                                </select>
                                <label htmlFor="tipo_relatorio" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Tipo do relatório</label>
                            </div>

                            <div className={`relative col-span-12 md:col-span-6 2xl:col-span-4 mt-1`}>
                                <SearchBox
                                    dataList={fornecedorList}
                                    idRegistro={idFornecedor || undefined}
                                    label='Fornecedor'
                                    componentId='fornecedor'
                                    visibleTAB={visibleSearchBoxFornecedor}
                                    setDataClick={handleFornecedorSelectClick}
                                    clearDataClick={handleClearFornecedorSelecionada}
                                    filterDataClick={handleFilterFornecedorClick}
                                    clicado={clickSearchBoxFornecedor}
                                />
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>

                                    <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>

                                </div>


                            </div>

                            <div className={`col-span-12 mt-1`}>

                                <div className={`flex flex-col md:flex-row justify-start w-full h-auto border border-slate-500 rounded-md bg-gray-200 dark:bg-slate-700`}>

                                    <div className={`w-full font-mono py-2 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                        <span className={`w-full md:w-auto`}>Duplicatas: </span>
                                        <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{qtdDup}</span>
                                    </div>

                                    <div className={`w-full font-mono py-2 px-2 dark:text-slate-200 flex flex-row`}>
                                        <span className={`w-full md:w-auto`}>Total: </span>
                                        <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}> {Funcoes.numberFormat(totDup, 'currency')}</span>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>

                        {tipoRelatorio === 'Res' &&
                            <GridRelDiaContaPagar relContaAPagar={dadosRelCtaPagar} tipoFiltro={tipoFiltro} />
                        }

                        {tipoRelatorio === 'Det' &&
                            <GridCtaPagarDetalhado duplicatas={dadosRelCtaPagarDet} tipoFiltro={tipoFiltro} />
                        }

                    </div>

                </div>

            </div>

        </Template>
    )
}